import { freePlayActionTypes } from '@/pages/freePlay/Constants';

import type { Category } from '@/pages/freePlay/types';
import type { Step } from '@/pages/learningPath/types';

export function getCategoriesRequest() {
	return {
		type: freePlayActionTypes.GET_CATEGORIES_REQUEST,
	};
}

export function getCategoriesSuccess(categories: Category[]) {
	return {
		type: freePlayActionTypes.GET_CATEGORIES_SUCCESS,
		payload: {
			categories,
		},
	};
}

export function getCategoriesError(error: any) {
	return {
		type: freePlayActionTypes.GET_CATEGORIES_ERROR,
		payload: {
			error,
		},
	};
}

export function getCategoryRequest(categoryId: number) {
	return {
		type: freePlayActionTypes.GET_CATEGORY_REQUEST,
		payload: {
			categoryId,
		},
	};
}

export function getCategorySuccess(category: any) {
	return {
		type: freePlayActionTypes.GET_CATEGORY_SUCCESS,
		payload: {
			category,
		},
	};
}

export function getCategoryError(error: any) {
	return {
		type: freePlayActionTypes.GET_CATEGORY_ERROR,
		payload: {
			error,
		},
	};
}

export function getLevelRequest(levelId: number) {
	return {
		type: freePlayActionTypes.GET_LEVEL_REQUEST,
		payload: {
			levelId,
		},
	};
}

export function getLevelSuccess(levelId: number, finishedSections: Step[]) {
	return {
		type: freePlayActionTypes.GET_LEVEL_SUCCESS,
		payload: {
			levelId,
			finishedSections,
		},
	};
}

export function getLevelError(error: any) {
	return {
		type: freePlayActionTypes.GET_LEVEL_ERROR,
		payload: {
			error,
		},
	};
}

export function resetCategory() {
	return {
		type: freePlayActionTypes.RESET_CATEGORY,
	};
}

export function setLevelProgress(levelProgress: any) {
	return {
		type: freePlayActionTypes.SET_LEVEL_PROGRESS,
		payload: {
			levelProgress,
		},
	};
}

export function setShowEntranceAnimation(showEntranceAnimation: boolean) {
	return {
		type: freePlayActionTypes.SET_SHOW_ENTRANCE_ANIMATION,
		payload: {
			showEntranceAnimation,
		},
	};
}

export function setOpenFinishedFirstQuestionSetSurvey(open: boolean) {
	return {
		type: freePlayActionTypes.SET_OPEN_FINISHED_FIRST_QUESTION_SET_SURVEY,
		payload: {
			open,
		},
	};
}
